export default __webpack_public_path__ + "4d7567947229c339b8d00b01e02d24e6.png";